import { MAX_AMOUNT_IN_USD_PER_WALLET, SEVEN_DAYS_IN_MS } from "constants/sale";
import { appStore } from "store";
import { userStore } from "store/user";
import { BonusProgram, Round } from "types";
import { refcodes } from "./../screens/Landing/constants";

export const scrollTo = (el: HTMLElement | null) => {
  if (el) {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export enum ClaimStatus {
  OngoingSale,
  NoSale,
  Claim,
}

export const formatAddress = (
  address: string,
  start: number = 6,
  end: number = 4
) => {
  return `${address.slice(0, start)}...${address.slice(-end)}`;
};

export const calcStatus = (): ClaimStatus => {
  const now = Date.now();
  const { currentRound } = appStore.getState();
  if (!currentRound) return ClaimStatus.Claim;

  const endOfSalesTimestamp = new Date(currentRound.finishAt).getTime();
  if (endOfSalesTimestamp > now) return ClaimStatus.OngoingSale;
  if (endOfSalesTimestamp + SEVEN_DAYS_IN_MS > now) return ClaimStatus.NoSale;

  return ClaimStatus.Claim;
};

export const calcAmountOfTokens = (
  valueInUSD: number,
  price = 1,
  maxAmountInUSD = MAX_AMOUNT_IN_USD_PER_WALLET
): number => {
  const amountOfTokens = valueInUSD / price;

  const multiplied = amountOfTokens * 100;

  const finalNumber = multiplied / 100;

  return parseFloat(finalNumber.toFixed(2));
};

export const calcAmountOfTokensToShow = (
  valueInUSD: number,
  round: Round | null,
  includeReferrerBonus: boolean | string = false,
  promocodeBonus?: number
) => {
  if (!round) return "0.00";

  const promocodePercentage = promocodeBonus || 0;

  const { user } = userStore.getState();
  const { currentReferralProgram } = appStore.getState();
  const amountOfTokens = valueInUSD / round.tokenPrice;
  let refPercent = currentReferralProgram?.refereeBonusPercentAmount;

  if (
    typeof includeReferrerBonus === "string" &&
    refcodes.includes(includeReferrerBonus)
  ) {
    refPercent = 10;
  }

  const referrerBonusPercentAmount = (refPercent || 0) / 100;

  let referrerBonusAmount = +(
    referrerBonusPercentAmount * amountOfTokens
  ).toFixed(2);

  if (
    !currentReferralProgram ||
    !includeReferrerBonus ||
    (currentReferralProgram?.minAmountToGetBonusEnabled &&
      amountOfTokens < currentReferralProgram.minAmountToGetBonus)
  ) {
    referrerBonusAmount = 0;
  }

  let promocodeBonusAmount = 0;
  if (promocodePercentage > 0) {
    const promocodeFactor = promocodePercentage / 100;
    promocodeBonusAmount = +(promocodeFactor * amountOfTokens).toFixed(2);
  }

  const baseTokens = amountOfTokens;
  const totalBonus = referrerBonusAmount + promocodeBonusAmount;

  const result = baseTokens + totalBonus;

  return result.toFixed(2);
};

export function truncateMiddle(address: string, front = 6, back = 4) {
  if (!address || address.length <= front + back + 3) return address;
  return `${address.slice(0, front)}...${address.slice(-back)}`;
}

export const formatAmount = (amount: number, decimals: number) => {
  const fixedString = amount ? amount.toFixed(decimals) : "0";

  const cleanNumber = parseFloat(fixedString);

  return cleanNumber.toString();
};

export * from "./globalErrorHandler";
